module.exports = __webpack_public_path__ + "static/media/318.a4f187ae.webp";